const Reportreducer = (state, { type, payload }) => {
    switch (type) {
        case 'setreport':
            return { ...state, income_punish: payload.income_punish, income_other: payload.income_other, income_scissors: payload.income_scissors, expense_punish: payload.expense_punish, expense_other: payload.expense_other, expense_scissors: payload.expense_scissors, expense_salary: payload.expense_salary, incomes: payload.incomes, expenses: payload.expenses, total_income: payload.total_income, total_expense: payload.total_expense, balance: payload.balance, total_loan: payload.total_loan, loan: payload.loan, daily_expense: payload.daily_expense, student_stat: payload.student_stat, isshow: true };
        default:
            return state;
    }
}

export default Reportreducer;